import React, { FC } from 'react'
import styles from '../styles.module.scss'
import { SubComponentProps } from '../types'

const Cell: FC<SubComponentProps> = ({ className, children }) => {
  return <td className={`${styles.tableCell} ${className}`}>{children}</td>
}

export default Cell
